"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserClient = void 0;
var models_1 = require("src/models");
var clients_1 = require("src/clients");
var classes_1 = require("src/classes");
var helpers_1 = require("src/helpers");
var errors_1 = require("src/errors");
/**
 * SDK for interacting with the User API documented at
 * [developer.domo.com](https://developer.domo.com/docs/dev-studio-references/user-api)
 */
var UserClient = /** @class */ (function () {
    function UserClient() {
    }
    UserClient.get = function (limit, offset, includeDetails, timeout) {
        if (limit === void 0) { limit = 50; }
        if (offset === void 0) { offset = 0; }
        if (includeDetails === void 0) { includeDetails = false; }
        if (timeout === void 0) { timeout = 0; }
        if (!(0, helpers_1.isNumber)(limit) || !(0, helpers_1.isNumber)(offset) || !(0, helpers_1.isBoolean)(includeDetails)) {
            throw new errors_1.InvalidParamError();
        }
        var params = new classes_1.URLSearchParams();
        params.set('limit', limit.toString());
        params.set('offset', offset.toString());
        params.set('includeDetails', includeDetails.toString());
        var url = models_1.EndpointsV1.user.toString();
        return clients_1.TransportClient.get(url, params.toString(), { accept: models_1.DataFormatTypes.json }, timeout);
    };
    UserClient.getUser = function (id, includeDetails, timeout) {
        if (includeDetails === void 0) { includeDetails = false; }
        if (timeout === void 0) { timeout = 0; }
        if (!(0, helpers_1.isNumber)(id) || !(0, helpers_1.isBoolean)(includeDetails))
            throw new errors_1.InvalidParamError();
        var params = new classes_1.URLSearchParams();
        params.set('includeDetails', includeDetails.toString());
        var url = "".concat(models_1.EndpointsV1.user, "/").concat(id);
        return clients_1.TransportClient.get(url, params.toString(), { accept: models_1.DataFormatTypes.json }, timeout);
    };
    UserClient.getAvatar = function (key, size, timeout) {
        if (size === void 0) { size = models_1.AvatarSizes.medium; }
        if (timeout === void 0) { timeout = 0; }
        if (!(0, helpers_1.isString)(key) || !(0, helpers_1.isString)(size) || !(0, helpers_1.isAvatarSizes)(size))
            throw new errors_1.InvalidParamError();
        var params = new classes_1.URLSearchParams();
        params.set('size', size);
        var url = "".concat(models_1.EndpointsV1.avatar, "/").concat(key);
        return clients_1.TransportClient.get(url, params.toString(), { accept: models_1.DataFormatTypes.json }, timeout);
    };
    return UserClient;
}());
exports.UserClient = UserClient;
